import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormatGhost',
})
export class TimeFormatGhostPipe implements PipeTransform {
  transform(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    let result = '';

    if (hours > 0) {
      result += `${this.formatTimeUnit(hours)}h `;
    }
    if (minutes > 0 || hours > 0) {
      result += `${this.formatTimeUnit(minutes)}m `;
    }
    result += `${this.formatTimeUnit(remainingSeconds)}s`;

    return result;
  }

  private formatTimeUnit(unit: number): string {
    // Convert number to string and replace each digit with '8' + non-breaking space character for padding
    return unit.toString().replace(/\d/g, '8') + '\u00A0';
  }
}
